<div>
  <div class="notification-title" *ngIf="title">
    {{title | cpTitleTranslate | async}}
  </div>
  <div class="notification-content" *ngIf="message">
    {{message | cpMessageTranslate | async}}
  </div>
</div>
<i class="pp-icon-close" (click)="this.close.emit()"></i>
